import React from 'react'
import { SimpleLoading, DialogSystemGLPure, SimpleFooterPure, DialogPrivacy } from '../../pures'
import './new-user-on-boarding.css'
import NewUserOnboardingConfigView from './new-user-on-boarding-config-view'
import NewUserOnboardingHeader from './new-user-on-boarding-header'

/**
 * @author Edgar Escobedo
 * @description Onboarding view component for new users who do not have a password and were not created in Auth0
 * @createdDate 08-10-2025
 * @typedef {object} Props
 * @property {boolean} isLoadingView - Indicates if the view is in a loading state
 * @property {boolean} showLoadingRequesting - Indicates if the loading dialog should be shown
 * @property {function(boolean): void} toggleLoadingRequesting - Function to toggle the loading dialog
 * @property {boolean} showCompletedRequesting - Indicates if the completed dialog should be shown
 * @property {function(): void} toggleCloseCompletedRequesting - Funciton to close the completed dialog
 * @property {boolean} showErrorRequesting - Indicates if the error dialog should be shown
 * @property {function(): void} toggleCloseErrorRequesting - Function to close the error dialog
 * @property {string} message - Message to be displayed in the dialog
 * @property {string} nameComponent - Name of the component to be displayed
 * @param {Props} props
 * @returns {JSX.Element} - The NewUserOnboardingView component
 */
const NewUserOnboardingView = (props) => {
  let {
    isLoadingView,
    showLoadingRequesting,
    toggleLoadingRequesting,
    showCompletedRequesting,
    toggleCloseCompletedRequesting,
    showErrorRequesting,
    toggleCloseErrorRequesting,
    message,
    messageComplete
  } = props

  if (isLoadingView) return <SimpleLoading />

  return (
    <div className='newUserOnboardingView-container'>
      <NewUserOnboardingHeader />
      <div className='standard-wrapper-onboarding'>
        <div className='newUserOnboardingView-body'>
          <NewUserOnboardingConfigView
            {...props}
          />
        </div>
      </div>
      <SimpleFooterPure />
      <DialogSystemGLPure
        showLoadingRequesting={showLoadingRequesting}
        toggleLoadingRequesting={toggleLoadingRequesting}

        showCompletedRequesting={showCompletedRequesting}
        toggleCompletedRequesting={toggleCloseCompletedRequesting}

        showErrorRequesting={showErrorRequesting}
        toggleErrorRequesting={toggleCloseErrorRequesting}

        message={message}
        messageComplete={messageComplete}
      />
      <DialogPrivacy {...props} modalTermsCond={props.showModalTermsCond} />
    </div>
  )
}

export { NewUserOnboardingView as default }